"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _String = _interopRequireDefault(require("./String.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Form section component
 *
 * @package HOPS
 * @subpackage Components
 * @copyright Heritage Operations Processing Limited
 */const FormSection = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
    gap: props.gap || 2,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      bold: true,
      str: props.label,
      variant: "h6"
    }), props.children]
  });
};
var _default = exports.default = FormSection;